import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import MedicalMain from './MedicalMain';

const MedicalEducation = () => {
  return (
    <>
      <HeaderSeven />
      <MedicalMain />
      <Footer />
    </>
  );
};

export default MedicalEducation;
